import preview from "./preview";

export default {
    labelIndex: 0,
    ...preview,

    createColumn(index) {
        const itemHeight = this.getHeight();
        const el         = document.createElement("div");

        const width = this.container.clientWidth - (this.settings.gap / 2 * this.settings.amount);

        Object.assign(el.style, {
            width: `${width}px`,
            height: `${itemHeight + this.settings.gap}px`,
            gridTemplateColumns: `repeat(${this.columns}, 1fr)`,
            gap: `${this.settings.gap}px`
        });

        el.dataset.index = index;
        el.classList.add("grid", "transition", "vrow");

        return el;
    },

    createImageBox(data, itemHeight) {
        const div = document.createElement("div");

        div.setAttribute("data-clarity-mask", "");

        div.classList.add(
            'img-clarity-mask',
            "bg-gray-700",
            "rounded-md",
            "relative",
            "border-2",
            "border-transparent",
            "group",
            "box-image",
            "select-none"
        );

        div.style.height = `${itemHeight}px`;

        div.addEventListener("mouseenter", () => {
            this.dispatchEvent("hover", { target: div, data });
        })

        div.addEventListener("mouseleave", () => {
            this.dispatchEvent("leave", { target: div, data });
        })

        return div;
    },

    createImage(columnIndex, element=null) {
        const itemHeight = this.getHeight();

        if(!element) {
            element = this.createColumn(columnIndex);
        }

        const images = _.get(this.chunkedItems, columnIndex, []);
        const fragment = document.createDocumentFragment();

        images.forEach(
            (imageObject, itemIndex) => {
                let div = null;

                if(!_.get(imageObject, 'element.style') || !_.get(imageObject, 'id')) {
                    div = this.createImageBox(imageObject, itemHeight);

                    Object.assign(div.style, {
                        backgroundImage: `url('${_.get(imageObject, "thumb")}')`,
                        backgroundSize: "contain",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                    });

                    imageObject.element = div;
                } else {
                    div = imageObject.element;
                    div.style.height = `${itemHeight}px`;

                    this.checkBox(div, false);

                    div.querySelectorAll('.buttons').forEach(
                        button => button.remove()
                    )
                }

                if(_.get(this.options, 'showPreview')) {
                    this.$nextTick(() => {
                        div.onmouseenter = () => this.setPreview(imageObject, div);
                        div.onmouseleave = () => this.setPreview(null, null, true);
                    })
                }

                queueMicrotask(() => this.renderButtons(imageObject, itemIndex));

                element.appendChild(div);
            }
        );

        fragment.appendChild(element);

        return {fragment, element};
    },

    createImageElement(imageObject, itemWidth, div){
        const image = document.createElement("img");

        image.loading = "lazy";
        image.draggable = false;

        image.id = 'image_' + _.get(imageObject, 'id');
        image.src = _.get(imageObject, 'thumb');

        image.classList.add(
            "border-none",
            "object-contain",
            "h-full",
            "w-full",
            "object-center",
            "prevent-browser-download"
        );

        image.width = `${itemWidth}px`;

        return image;
    },

    createTopButtons(image, box, index) {
        const element     = document.createElement("div");
        const canSelect   = this.checkIfCan("select", image);
        const canFavorite = this.checkIfCan("favorite");

        element.classList.add("top-buttons", "buttons");

        if (canSelect && _.has(image, 'id')) {
            const selectButton = this.createSelectInput("select", image, box);
            const input = selectButton.querySelector("input");

            this.checkBox(box, input.checked);

            box.addEventListener("click",  ({ shiftKey }) => {
                const newEvent = new CustomEvent('box-click', {
                    detail: {shiftKey}
                });

                input.dispatchEvent(newEvent)
            });

            element.appendChild(selectButton);
        }

        if (this.checkIfCan("preview", image)) {
            const previewButton = this.createButton("previewIcon", "preview", {
                ...image,
                index,
            });

            if (!canSelect) {
                this.checkBox(box, false);

                box.addEventListener("click", () => {
                    if(_.has(image, "preview") && !this.checkIfCan("select", image)) {
                        previewButton.click();
                    }
                });
            } else {
                element.appendChild(previewButton);
            }
        }

        if (canFavorite) {
            let shouldToggleIcon = this.isFavorited(image);

            if (_.get(this.options, "canCreateAccount")) {
                shouldToggleIcon = shouldToggleIcon && this.$store.customer?.hasInfo();
            }

            const favoriteIcon = shouldToggleIcon
                ? "favoritedIcon"
                : "unfavoritedIcon";

            const favoriteButton = this.createButton(
                favoriteIcon,
                "favorite",
                image
            );

            favoriteButton.addEventListener("click", () => this.renderButtons(image, index));
            element.appendChild(favoriteButton);
        }

        if (this.checkIfCan("deleteTop", image)) {
            const deleteButton = this.createButton("trash", "delete", image);

            deleteButton.addEventListener("click", () => this.render());
            element.appendChild(deleteButton);
        }

        if(element.childElementCount) {
            element.classList.add(
                "absolute", "top-0", "left-0", "w-full", "h-10",
                "flex",  "items-center", "justify-between", "px-2"
            );

            if (canFavorite) {
                element.classList.remove("left-0", "justify-between");
                element.classList.add("right-0", "justify-end");
            }
        }

        return element;
    },

    createBottomButtons(image, index) {
        const element = document.createElement("div");

        element.classList.add("bottom-buttons", "buttons");

        if (this.checkIfCan("download", image)) {
            const downloadButton = this.createButton(
                "downloadIcon",
                "download",
                image
            );

            downloadButton.addEventListener('click', () => {
                if (downloadButton.disabled) return;

                const iconElement = this.cloneIcon('spinner');

                downloadButton.textContent = null;
                downloadButton.disabled = true;

                downloadButton.appendChild(iconElement)
            })

            element.appendChild(downloadButton);
        }

        if (this.checkIfIsPrintOnly(image)) {
            const printOnlyButton = this.createButton(
                "printOnlyIcon",
                "print-only",
                image,
                "print only"
            );

            element.appendChild(printOnlyButton);
        }

        if (this.checkIfCanReadyToDownload(image)) {
            const downloadButton = this.createButton(
                "downloadIcon",
                "download",
                image,
                "ready"
            );

            downloadButton.addEventListener('click', () => {
                const iconElement = this.cloneIcon('spinner');
                iconElement.classList.add('text-white');

                downloadButton.textContent = null;
                downloadButton.disabled = true;

                downloadButton.appendChild(iconElement)
            })

            element.appendChild(downloadButton);
        }


        if (this.checkIfCanPrepareToDownload(image)) {
            const prepareToDownload = this.createButton(
                "refreshIcon",
                "refresh",
                image,
                "processing"
            );

            element.appendChild(prepareToDownload);
        }

       if (this.checkIfCan("save", image) && !this.checkIfCanReadyToDownload(image) && (image.paid === 0 || image.paid == null)) {
            let shouldToggleIcon = this.isSaved(image);

            if (_.get(this.options, "canCreateAccount")) {
                shouldToggleIcon = shouldToggleIcon && this.$store.customer?.hasInfo();
            }

            let text = null;
            let saveIcon = 'spinner';

            if(_.has(image, "id")) {
                saveIcon = shouldToggleIcon ? "savedIcon" : "unsavedIcon";
                text = !shouldToggleIcon && !this.checkIfIsPrintOnly(image)
                    ? "Add to Album"
                    : null;
            }

            const saveButton = this.createButton(saveIcon, "save", image, text);
            saveButton.classList.add('save-button', 'cursor-not-allowed');

            if(_.has(image, "id")) {
                saveButton.classList.remove('cursor-not-allowed');
                saveButton.addEventListener("click", () => {
                    this.renderButtons(image, index);

                    this.$nextTick(() => {
                        if (shouldToggleIcon || !this.$store.customer?.hasInfo()) return;

                        const button = image.element.querySelector('.save-button');
                        button.classList.remove('hover:opacity-75');
                        button.classList.add('animate-like');

                        image.element.classList.add('overflow-hidden');
                    });
                });
            }

            element.appendChild(saveButton);
        }

        if(_.has(this.options, 'imageLabel')) {
            const imageLabel = this.createImageLabel(image);
            if(imageLabel) element.appendChild(imageLabel);
        }

        if(_.has(this.options, 'imageLabelWhite')) {
            const imageLabelWhite = this.createImageLabelWhite(image);
            if(imageLabelWhite) element.appendChild(imageLabelWhite);
        }

        if (this.checkIfCan("delete", image)) {
            const deleteButton = this.createButton("trash", "delete", image);

            deleteButton.addEventListener("click", () => this.render());
            element.appendChild(deleteButton);
        }

        if (this.checkIfCan("restore", image)) {
            const restoreButton = this.createButton("refresh", "restore", image);

            restoreButton.addEventListener("click", () => this.render());
            element.appendChild(restoreButton);
        }

        if (_.get(this.options, "quickBuy")) {
            this.$nextTick(() => {
                element.classList.remove("justify-between");
                element.classList.add("justify-end");
            });

            const buyPhotoButton = this.createQuickBuyButton(image, index);

            element.appendChild(buyPhotoButton);
        }

        if(element.childElementCount) {
            element.classList.add(
                "absolute", "bottom-0", "left-0", "w-full", "h-10",
                "flex", "items-center", "px-2", "justify-between",
            );

            if (this.checkIfCan("save", image) && !this.checkIfCanReadyToDownload(image) && (image.paid === 0 || image.paid == null)) {
                element.classList.remove("left-0", "justify-between");
                element.classList.add("right-0", "justify-end");
            }

            if (_.has(this.options, 'imageLabelWhite')) {
                element.classList.remove("left-0", "justify-between");
                element.classList.add("right-0", "justify-end");
            }

            if (this.checkIfIsPrintOnly(image)) {
                element.classList.add("justify-between");
            }

            if (this.checkIfCanReadyToDownload(image) || this.checkIfCanPrepareToDownload(image)) {
                element.classList.add(
                    "absolute", "bottom-0", "left-0", "w-full", "h-10",
                    "flex", "items-center", "px-2", "justify-end",
                );
            }
        }

        if (_.get(this.options, "showTeams", false)) {
            this.showTeams(element, image);
        }

        return element;
    },

    cloneIcon(iconName) {
        return document.querySelector(`.virtual-icon [x-ref=${iconName}]`)
            ?.cloneNode(true)
    },

    createQuickBuyButton(image, index) {
        const buyPhotoButton = this.createButton(
            "plusCartIcon",
            "buy-photo",
            image,
            "Buy Photo",
        );

        buyPhotoButton.addEventListener("click", (event) => {
            if(! _.has(image, "preview")) {
                return;
            }

            this.dispatchEvent('preview', {
                ...image,
                index,
            });

            event.stopPropagation();
        });

        return buyPhotoButton;
    },

    createImageLabel(image) {
        let label = _.get(this.options, 'imageLabel');

        if(typeof label === "function") {
            label = label(image);
        }

        if(_.isEmpty(label)) {
            return null;
        }

        const element = document.createElement("span");

        element.setAttribute('class', 'text-xs text-white p-1 bg-gray-800/70 px-2 rounded-xl -mb-1 -ml-1');
        element.textContent = label;

        return element;
    },

    createImageLabelWhite(image) {
        let label = _.get(this.options, 'imageLabelWhite');

        if(typeof label === "function") {
            label = label(image);
        }

        if(_.isEmpty(label)) {
            return null;
        }

        const element = document.createElement("span");

        element.setAttribute('class', 'text-2xs h-6 gap-1 flex items-center text-gray-900 font-semibold py-0.5 bg-white px-3 rounded-xl -mb-1 -ml-1');
        element.textContent = label;

        return element;
    },

    createButton(iconName, eventName, data = {}, text = null) {
        const iconElement = this.cloneIcon(iconName);
        const element     = document.createElement("div");
        const clickable = !['refreshIcon', 'printOnlyIcon'].includes(iconName);

        eventName === 'download' && element.classList.add('block', 'absolute', 'left-1');

        element.classList.toggle('cursor-pointer', clickable);
        element.classList.add('rounded-full', 'p-1', 'button');
        element.classList.toggle('hover:opacity-75', clickable);
        element.classList.toggle('bg-orange-400', iconName === 'refreshIcon');
        element.classList.toggle('bg-green-500',  iconName === 'downloadIcon' && text);
        element.classList.toggle('bg-white', iconName === 'downloadIcon' && !text);
        element.classList.toggle('bg-blue-500', iconName === 'printOnlyIcon');
        element.classList.toggle('bg-gray-100', !['refreshIcon', 'downloadIcon', 'printOnlyIcon'].includes(iconName));

        element.id = this.$id(`${eventName}-${data.id}`);

        element.onclick = (event) => {
            if (eventName === 'download') {
                this.$dispatch('track-download', { photo: data });
            }
            
            this.dispatchEvent(eventName, data);
            event.stopPropagation();
        };

        if (text) {
            element.classList.remove('p-1');
            element.classList.add('flex', 'items-center', 'py-1', 'px-1.5');

            const textElement = document.createElement("span");

            textElement.setAttribute('class', `
                uppercase font-bold text-[10px] tracking-[0.5px]
                text-gray-600 pt-0.5 mr-0.5 ml-1.5
            `);

            if (['refreshIcon', 'downloadIcon', 'download', 'printOnlyIcon'].includes(iconName)) {
                textElement.classList.remove("text-gray-600", "text-[10px]");
                textElement.classList.add("text-white", "text-xs");
            }

            textElement.textContent = text;
            element.appendChild(textElement);
        }

        if(iconElement) {
            element.appendChild(iconElement);

            if (iconName === 'refreshIcon' || (iconName === 'downloadIcon' && text)) {
                iconElement.classList.add('text-white');
            }

            if (iconName === 'downloadIcon' && !text) {
                iconElement.classList.add('text-blue-500');
            }
        } else {
            console.error(`Icon ${iconName} not found!`);
        }

        return element;
    },

    createSelectInput(eventName, data, box) {
        const element = document.createElement("div");
        const input = document.createElement("input");

        element.classList.add(
            "absolute", "top-2", "right-2", "h-6", "w-6", "text-center",
            "bg-white", "border-none", "rounded-full", "shadow-soft",
            "hidden", "sm:block"
        );

        input.type    = "checkbox";
        input.checked = this.checkIfSelected(data.id);

        if (this.isDisabled(data) && !input.checked) {
            box.classList.add("cursor-not-allowed");
        }

        input.id = this.$id(`select-photo-modal-${data.id}`);

        input.classList.add(
            "h-4", "w-4", "rounded-full", "p-1", "border-2", "border-gray-300",
             "text-green-600", "form-checkbox", "focus:ring-green-500"
        );

        input.onchange = () => {
            input.checked
                ? box.classList.add("selected")
                : box.classList.remove("selected");

            this.checkInputSelected(input, data);
            this.checkBox(box, input.checked);

            this.dispatchEvent(eventName, {
                data,
                selected: input.checked,
                selectedIds: this.selected,
                shiftKey: JSON.parse(_.get(input.dataset, 'shift', false)),
            });

            this.checkIfCanSelect();

            this.$el.querySelectorAll(
                    this.isDisabled(data)
                    ? ".box-image:not(.selected)"
                    : ".box-image.cursor-not-allowed"
                )
                .forEach((item) => {
                    item.classList.toggle("cursor-not-allowed");
                });

            input.dataset.shift = null;
        };

        input.addEventListener("box-click", ({ detail }) => {
            input.dataset.shift = _.get(detail, 'shiftKey', false);
            input.click();
        });

        input.onclick = (event) => {
            event.stopPropagation();

            if(!input.dataset.shift) {
                input.dataset.shift = _.get(event, 'shiftKey', false);
            }

            if (input.checked && this.isDisabled(data)) {
                event.preventDefault();
            }
        };

        element.appendChild(input);
        this.checkInputSelected(input, data);

        return element;
    },

    createGroupedLabel(currentFragment=null, imageObject={}) {
        const labelElement = this.$el.querySelector(`[data-label="${this.label}"]`);
        const labelClass = _.get(this.options, 'labelClass');
        const fragment = currentFragment ?? this.fragment;

        let labelText = typeof this.label === "function"
            ? this.label(imageObject)
            : this.label;

        labelText ??= 'Loading...';

        if(labelElement) {
            this.labelIndex = labelElement.dataset.labelIndex;
            fragment.appendChild(labelElement);
            return;
        }

        this.labelIndex += 1;
        const label = document.createElement("div");
        const div = document.createElement("div");

        div.setAttribute('class', `${labelClass} z-30 text-sm sticky w-full py-1`);

        label.dataset.label = labelText;
        label.dataset.labelIndex = this.labelIndex;
        label.classList.add('label', 'relative');

        div.classList.add(
            'bg-light-gray-200', 'z-50', 'text-base', 'leading-5',
            'sticky', 'w-full', 'py-1', 'font-medium',
        );

        div.style.top = '-1px';

        if(typeof this.label !== "object") {
            if (String(this.label).includes('#')) {
                const [day, match] = this.label.split('#');

                div.innerHTML = `
                    <div class="flex items-center gap-1 sm:gap-3 divide-x pr-1 sm:pr-3 py-5">
                        <div class="text-xs text-gray-700 uppercase">
                            ${day}
                        </div>

                        <div class="font-medium text-base leading-5 pl-1 sm:pl-3">
                            ${match}
                        </div>

                        <div class="h-0.5 bg-gray-200 flex-1"></div>
                    </div>
                `;
            } else {
                div.innerHTML = labelText;
            }
        } else {
            div.append(labelText);
        }

        label.appendChild(div);
        fragment.appendChild(label);
    },

    createLabel(el, fragment, imageObject, itemIndex) {
        let currentLabel = null;

        if(!this.grouped) {
            return;
        }

        if(_.get(this.options, 'label') !== null && _.has(imageObject, 'id')) {
            let label = this.options.label;

            currentLabel = typeof label === "function"
                ? label(imageObject)
                : label;
        } else {
            currentLabel = _.get(imageObject, this.options.groupBy);
        }

        if(this.label !== currentLabel) {
            currentLabel = currentLabel?.replace(/[\n\r]/g, ' ');

            if(itemIndex !== 0) {
                fragment.appendChild(el);
            }

            this.label = currentLabel;
            this.createGroupedLabel(fragment, imageObject);

            return true;
        }

        return false;
    },

    showTeams(element, image) {
        const box = document.createElement("div");
        const colors = _.get(this.options, 'colors', {});

        box.className = 'flex flex-col gap-1 text-white text-2xs -ml-1 mr-2 overflow-hidden absolute left-2 bottom-2';
        box.style.maxWidth = '60%';

        const lightBulbIcon = this.cloneIcon('lightBulbIcon');

        _.get(image, 'teams', []).forEach((team) => {
            const teamColor = _.get(colors, team.id);
            const teamElement = document.createElement("div");

            teamElement.className = `
            p-1 px-2 rounded-md border border-white bg-gray-800
            font-semibold flex gap-1
            `;

            if(teamColor) {
                teamElement.style.backgroundColor = teamColor;

                if(teamColor.includes('FFF') || teamColor.includes('D6D')) {
                    teamElement.classList.add('text-gray-800');
                }
            }

            teamElement.innerHTML = `<div class="flex-1 overflow-hidden whitespace-nowrap text-ellipsis">${_.get(team, 'name')}</div>`;

            box.prepend(teamElement);

            if (_.get(team, 'pivot.tagged_by_photo_tagging_job')) {
                teamElement.prepend(lightBulbIcon.cloneNode(true));
            }
        });

        element.prepend(box);
    }
}
